export const XP_PER_LEVEL = 1000

export const getUserXpValue = user =>
  Number(user?.xp_points ?? user?.total_xp ?? user?.xp_point?.points) || 0

export const getXpLevel = xp => {
  const value = Math.max(0, Number(xp) || 0)
  if (value < XP_PER_LEVEL) return 1
  return Math.floor(value / XP_PER_LEVEL) + 1
}

export const getNextLevelXpTarget = level =>
  Math.max(1, Number(level) || 1) * XP_PER_LEVEL

export const getXpProgress = userOrXp => {
  const xpValue =
    userOrXp != null && typeof userOrXp === "object"
      ? getUserXpValue(userOrXp)
      : Math.max(0, Number(userOrXp) || 0)
  const xpLevel = getXpLevel(xpValue)
  return {
    xpValue,
    xpLevel,
    xpMax: getNextLevelXpTarget(xpLevel),
  }
}
